import type { Redaction } from "../../../shared/types";

export function RedactionProps({ r, n, onChange, onDelete }: {
  r: Redaction;
  n: number;
  onChange: (p: Partial<Redaction>) => void;
  onDelete: () => void;
}) {
  return (
    <div className="panel stack-s">
      <div className="row" style={{ justifyContent: "space-between" }}>
        <h3>Redaction {n}</h3>
      </div>
      <div className="field">
        <span>Style</span>
        <div className="tool-group" role="radiogroup" aria-label="Redaction style">
          <button
            type="button"
            role="radio"
            aria-checked={r.type === "blur"}
            className={`tool ${r.type === "blur" ? "on" : ""}`}
            onClick={() => onChange({ type: "blur" })}
          >
            Blur
          </button>
          <button
            type="button"
            role="radio"
            aria-checked={r.type === "blackout"}
            className={`tool ${r.type === "blackout" ? "on" : ""}`}
            onClick={() => onChange({ type: "blackout" })}
          >
            Blackout
          </button>
        </div>
      </div>
      <div className="grid-2 small">
        <label className="field">
          <span>Left %</span>
          <input
            type="number"
            min={0}
            max={100}
            step={0.5}
            value={r.x}
            onChange={(e) => onChange({ x: Math.min(100 - r.w, Math.max(0, Number(e.target.value) || 0)) })}
          />
        </label>
        <label className="field">
          <span>Top %</span>
          <input
            type="number"
            min={0}
            max={100}
            step={0.5}
            value={r.y}
            onChange={(e) => onChange({ y: Math.min(100 - r.h, Math.max(0, Number(e.target.value) || 0)) })}
          />
        </label>
        <label className="field">
          <span>Width %</span>
          <input
            type="number"
            min={1}
            max={100}
            step={0.5}
            value={r.w}
            onChange={(e) => onChange({ w: Math.min(100 - r.x, Math.max(1, Number(e.target.value) || 1)) })}
          />
        </label>
        <label className="field">
          <span>Height %</span>
          <input
            type="number"
            min={1}
            max={100}
            step={0.5}
            value={r.h}
            onChange={(e) => onChange({ h: Math.min(100 - r.y, Math.max(1, Number(e.target.value) || 1)) })}
          />
        </label>
      </div>
      <div>
        <button type="button" className="btn btn-danger btn-sm" onClick={onDelete}>Remove redaction</button>
      </div>
    </div>
  );
}
